import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useFamily } from '../../context/FamilyContext';
import { calculateBalance } from '@coparent/shared/src/services/expenseService';
import { formatCurrency } from '../../utils/expenseUtils';
import { HiArrowRight } from 'react-icons/hi';

const BalanceSummary = ({ expenses, onSettleUp }) => {
  const { currentUser } = useAuth();
  const { family } = useFamily();

  if (!family || family.parentIds.length < 2 || !expenses.length) return null;

  const balance = calculateBalance(expenses, family.parentIds, family.householdMembers || {});

  if (balance.amount === 0) {
    return (
      <div className="card bg-shared-50/50 border-shared-200/60 p-5 text-center">
        <p className="text-shared-700 font-semibold text-sm">All settled up!</p>
      </div>
    );
  }

  const owerProfile = family.parentProfiles[balance.owerId];
  const oweeProfile = family.parentProfiles[balance.oweeId];
  const isCurrentUserOwer = balance.owerId === currentUser.uid;

  return (
    <div className={`card p-6 ${
      isCurrentUserOwer ? 'bg-amber-50/50 border-amber-200/60' : 'bg-parent1-50/50 border-parent1-200/60'
    }`}>
      <div className="flex items-center justify-center gap-5">
        <div className="text-center">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white text-sm font-bold mx-auto ring-2 ring-white shadow-warm-sm"
            style={{ backgroundColor: owerProfile?.color }}
          >
            {owerProfile?.displayName?.[0]}
          </div>
          <p className="text-xs text-ink-500 mt-1.5 font-medium">{owerProfile?.displayName}</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-ink-900 tracking-tight">{formatCurrency(balance.amount)}</p>
          <HiArrowRight className="text-ink-300 mx-auto mt-0.5" />
        </div>
        <div className="text-center">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white text-sm font-bold mx-auto ring-2 ring-white shadow-warm-sm"
            style={{ backgroundColor: oweeProfile?.color }}
          >
            {oweeProfile?.displayName?.[0]}
          </div>
          <p className="text-xs text-ink-500 mt-1.5 font-medium">{oweeProfile?.displayName}</p>
        </div>
      </div>
      <p className="text-center text-sm text-ink-500 mt-4 font-medium">
        {isCurrentUserOwer
          ? `You owe ${oweeProfile?.displayName} ${formatCurrency(balance.amount)}`
          : `${owerProfile?.displayName} owes you ${formatCurrency(balance.amount)}`
        }
      </p>
      {onSettleUp && (
        <div className="text-center mt-4">
          <button
            onClick={onSettleUp}
            className="btn-primary text-sm px-5 py-2"
          >
            Settle Up
          </button>
        </div>
      )}
    </div>
  );
};

export default BalanceSummary;
